/**
 * RBAC-8.2 · Read the account's role change log and what appears in it.
 *
 * ⚠️ THIS MODULE HOLDS NO RULES AND READS NO TABLE. `role_audit_events` has no API grant; who may read
 * it and what is logged are `20261103a5`. What a row means is `lib/roleAudit.ts`. Errors carry the
 * server's sentence verbatim, as RBAC-3.6's and 8.1's do.
 */

import { supabase } from '@/lib/supabaseClient';
import {
  ROLE_AUDIT_FACETS_RPC,
  ROLE_AUDIT_LOG_RPC,
  parseRoleAuditFacets,
  parseRoleAuditPage,
  roleAuditArgs,
  type RoleAuditFacets,
  type RoleAuditFilters,
  type RoleAuditPage,
} from '@/lib/roleAudit';
import { RoleSaveError } from '@/services/roleSaveService';

const unreadable = (what: string) =>
  new RoleSaveError({ message: `${what} came back in a shape this screen does not understand. Reload to try again.` });

export async function fetchRoleAuditPage(filters: RoleAuditFilters, beforeId: number | null): Promise<RoleAuditPage> {
  const { data, error } = await supabase.rpc(ROLE_AUDIT_LOG_RPC, roleAuditArgs(filters, beforeId));
  if (error) throw new RoleSaveError(error);
  const page = parseRoleAuditPage(data);
  if (!page) throw unreadable('The list of changes');
  return page;
}

export async function fetchRoleAuditFacets(): Promise<RoleAuditFacets> {
  const { data, error } = await supabase.rpc(ROLE_AUDIT_FACETS_RPC);
  if (error) throw new RoleSaveError(error);
  const f = parseRoleAuditFacets(data);
  if (!f) throw unreadable('The filters');
  return f;
}
